import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { getCoOwners } from '../redux/coOwnerActions';

type UseGetCoOwnersProps = {
  encumbranceId?: string;
  page?: number;
  rowsPerPage?: number;
};

export const useGetCoOwners = ({
  encumbranceId,
  page = 1,
  rowsPerPage = 10,
}: UseGetCoOwnersProps) => {
  const [totalCoOwners, setTotalCoOwners] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchCoOwners = useCallback(
    async (controller: AbortController) => {
      if (!encumbranceId) return;

      try {
        setIsLoading(true);

        const response = await store.dispatch(
          getCoOwners({
            encumbranceId,
            params: { page, items: rowsPerPage },
            signal: controller.signal,
          })
        );

        if (!controller.signal.aborted) {
          setTotalCoOwners(response.total);
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    [encumbranceId, page, rowsPerPage]
  );

  useEffect(() => {
    const controller = new AbortController();
    fetchCoOwners(controller);
    return () => controller.abort();
  }, [fetchCoOwners]);

  return {
    data: {
      totalCoOwners,
    },
    isLoading,
    isError,
  };
};
